// extracted by mini-css-extract-plugin
export default {"boardContainer":"styles_boardContainer__hLVkq","infoContainer":"styles_infoContainer__n655H","img":"styles_img__zmAjh","button":"styles_button__3ZQJJ"};